import { DriversbyRides } from '@/core/domain/entities/Ride'

export enum Period {
  Today = 'today',
  Yesterday = 'yesterday',
  ThisWeek = 'thisWeek',
  LastWeek = 'lastWeek',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  ThisYear = 'thisYear',
  LastYear = 'lastYear',
  Custom = 'custom',
}

export interface SolicitationMetrics {
  total: number
  accepted: number
  refused: number
  canceled: number
  pending: number
  lastUpdatedAt?: string
}

export interface DashboardSummary {
  totalDrivers: number
  onlineDrivers: number
  offlineDrivers: number
  averageRating: number
  onlinePercentage: number
  totalRides: number
  canceledRides: number
  totalEarnings: string
  subscription: number
  ridesPerDriver: string
  topDriversByRides: DriversbyRides[]
  lowDriversByRides: DriversbyRides[]
  ridesPerDriverList: DriversbyRides[]
  lastUpdatedAt?: string
}

export interface DriverSummary {
  id: string
  name: string
  email?: string
  phone?: string
  totalRides: number
  totalRevenue: number
  averageRating: number
  status: 'active' | 'inactive'
  lastRide?: Date
  classification?: string
  acceptsCash?: number
}
